interface ToastConstants {
  SUCCESS_TIMEOUT: number;
  INFO_TIMEOUT: number;
  ERROR_TIMEOUT: number;
  WARNING_TIMEOUT: number;
  NOTICE_TIMEOUT: number;
}

export const toastConstants: ToastConstants = {
  SUCCESS_TIMEOUT: 500,
  INFO_TIMEOUT: 3000,
  ERROR_TIMEOUT: 5000,
  WARNING_TIMEOUT: 10000,
  NOTICE_TIMEOUT: 20000,
};
